import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ColorVariable, DefaultColors } from "src/app/constants/style-variables";
import { SessionStatus } from '../constants/session';
import { SessionService } from './storage/session.service';

@Injectable()
export class StyleService {
    public sessionStore: Observable<any>;

    constructor(
        private sessionService: SessionService
    ) {
        // this.sessionStore = this.sessionService.$SessionClear;
        // this.sessionStore.subscribe((status: string) => {
        //     switch (status) {
        //         case SessionStatus.initalize:
        //             this.configureCSSVariable(this.sessionService.session.isDarkMode);
        //             break;
        //     }
        // });
    }

    public setDarkModeIntial(isDarkMode: boolean): void {
        this.sessionService.session.isDarkMode = isDarkMode;
        this.sessionService.session.isFirstLoad = false;
        this.sessionService.setSession();
        this.configureCSSVariable(this.sessionService.session.isDarkMode);
    }

    public setDarkMode(isDarkMode: boolean): void {
        this.sessionService.session.isDarkMode = isDarkMode;
        this.sessionService.setSession();
        this.configureCSSVariable(this.sessionService.session.isDarkMode);
    }

    public setStyle(): void {
        this.configureCSSVariable(this.sessionService.session.isDarkMode);
    }

    private configureCSSVariable(isDarkMode: boolean): void {
        // Primary
        let l_PrimaryColor: string = DefaultColors.primary;
        // let l_PrimaryRGB: string = DefaultColors.primaryRGB;
        let l_primaryButton: string = DefaultColors.primaryButton;

        // Secondary
        let l_Secondary: string = DefaultColors.secondary;

        // Font Color
        let l_FontColor: string = DefaultColors.font;
        let l_FontTitleColor: string = DefaultColors.fontTitle;
        let l_dataHeader: string = DefaultColors.dataHeader;
        let l_data: string = DefaultColors.data;
        let l_errorFont: string = DefaultColors.errorFont;
        let l_inputPlaceHolderText: string = DefaultColors.inputPlaceHolderText;
        let l_instructionContainerFontColor: string = DefaultColors.instructionContainerFontColor;
        let l_materialFont: string = DefaultColors.materialFont;
        let l_hyperLinkColor: string = DefaultColors.hyperLinkColor;
        let l_headerButtonFontColor: string = DefaultColors.headerButtonFontColor;
        let l_formLabel: string = DefaultColors.formLabel;
        let l_devxlabelOne: string = DefaultColors.devxlabelOne;
        let l_devxlabelTwo: string = DefaultColors.devxlabelTwo;

        // Background
        let l_Background: string = DefaultColors.background;
        let l_inputBackground: string = DefaultColors.inputBackground;
        let l_errorBackground: string = DefaultColors.errorBackground;
        let l_loadingBackground: string = DefaultColors.loadingBackground;
        let l_contentContainerBackground: string = DefaultColors.contentContainerBackground;
        let l_contentHeaderNoteBackground: string = DefaultColors.contentHeaderNoteBackground;
        let l_checkboxSelectedBackground: string = DefaultColors.checkboxSelectedBackground;
        let l_checkboxUnselectedBackground: string = DefaultColors.checkboxUnselectedBackground;
        let l_payStubTotalBackground: string = DefaultColors.payStubTotalBackground;
        let l_materialFormDisabledbackground: string = DefaultColors.materialFormDisabledbackground;
        let l_childTableRowBackground: string = DefaultColors.childTableRowBackground;
        let l_childTableBackground: string = DefaultColors.childTableBackground;
        let l_headerFooterBackground: string = DefaultColors.headerFooterBackground;
        let l_headerSeperator: string = DefaultColors.headerSeperator;
        let l_headerBoxShadow: string = DefaultColors.headerBoxShadow;
        let l_subHeaderBackground: string = DefaultColors.subHeaderBackground;

        // Button
        let l_buttonMenuLinkHovered: string = DefaultColors.buttonMenuLinkHovered;
        let l_buttonRegisterFontReg: string = DefaultColors.buttonRegisterFontReg;
        let l_buttonRegisterFontHovered: string = DefaultColors.buttonRegisterFontHovered;
        let l_buttonRegisterHovered: string = DefaultColors.buttonRegisterHovered;
        let l_buttonPrimaryFontReg: string = DefaultColors.buttonPrimaryFontReg;
        let l_buttonPrimaryFontHovered: string = DefaultColors.buttonPrimaryFontHovered;
        let l_buttonPrimaryFontActive: string = DefaultColors.buttonPrimaryFontActive;
        let l_buttonPrimaryFontDisabled: string = DefaultColors.buttonPrimaryFontDisabled;
        let l_buttonPrimaryBackgroundReg: string = DefaultColors.buttonPrimaryBackgroundReg;
        let l_buttonPrimaryBackgroundHovered: string = DefaultColors.buttonPrimaryBackgroundHovered;
        let l_buttonPrimaryBackgroundActive: string = DefaultColors.buttonPrimaryBackgroundActive;
        let l_buttonPrimaryBackgroundDisabled: string = DefaultColors.buttonPrimaryBackgroundDisabled;
        let l_buttonSecondaryFontReg: string = DefaultColors.buttonSecondaryFontReg;
        let l_buttonSecondaryFontHovered: string = DefaultColors.buttonSecondaryFontHovered;
        let l_buttonSecondaryFontActive: string = DefaultColors.buttonSecondaryFontActive;
        let l_buttonSecondaryFontDisabled: string = DefaultColors.buttonSecondaryFontDisabled;
        let l_buttonSecondaryBackgroundHovered: string = DefaultColors.buttonSecondaryBackgroundHovered;
        let l_buttonSecondaryBackgroundActive: string = DefaultColors.buttonSecondaryBackgroundActive;


        // Other
        let l_border: string = DefaultColors.border;
        let l_radioButtonUnselected: string = DefaultColors.radioButtonUnselected;
        let l_radioButtonSelected: string = DefaultColors.radioButtonSelected;
        let l_toggleButtonSelected: string = DefaultColors.toggleButtonSelected;
        let l_materialFieldBorder: string = DefaultColors.materialFieldBorder;
        let l_appDividerContainer: string = DefaultColors.appDividerContainer;
        let l_materialFormDisabledFont: string = DefaultColors.materialFormDisabledFont;
        let l_materialFormDisabledBorder: string = DefaultColors.materialFormDisabledBorder;
        let l_tableBorder: string = DefaultColors.tableBorder;
        let l_footerBorderColor: string = DefaultColors.footerBorderColor;
        let l_dropdownIcon: string = DefaultColors.dropdownIcon;
        let l_selectionContentActive: string = DefaultColors.selectionContentActive;


        // New Controls
        let l_newControlEnabledBackground: string = DefaultColors.newControlEnabledBackground;
        let l_newControlEnabledBorder: string = DefaultColors.newControlEnabledBorder;
        let l_newControlEnabledUnselected: string = DefaultColors.newControlEnabledUnselected;
        let l_newControlEnabledSelected: string = DefaultColors.newControlEnabledSelected;

        let l_newControlDisabledBackground: string = DefaultColors.newControlDisabledBackground;
        let l_newControlDisabledBorder: string = DefaultColors.newControlDisabledBorder;
        let l_newControlDisabledUnselected: string = DefaultColors.newControlDisabledUnselected;
        let l_newControlDisabledSelected: string = DefaultColors.newControlDisabledSelected;

        // Toastr
        let l_toastSucces: string = DefaultColors.toastSucces;
        let l_toastSuccesBackground: string = DefaultColors.toastSuccesBackground;
        let l_toastError: string = DefaultColors.toastError;
        let l_toastErrorBackground: string = DefaultColors.toastErrorBackground;
        let l_toastInfo: string = DefaultColors.toastInfo;
        let l_toastInfoBackground: string = DefaultColors. toastInfoBackground;
        let l_toastWarning: string = DefaultColors.toastWarning;
        let l_toastWarningBackground: string = DefaultColors.toastWarningBackground;

        //In Page NavBar Icon Backgrounds
        let l_navBarIconBlue: string = DefaultColors.navBarIconBlue;
        let l_navBarIconMint: string = DefaultColors.navBarIconMint;
        let l_navBarIconCoral: string = DefaultColors.navBarIconCoral;
        let l_navBarIconCyan: string = DefaultColors.navBarIconCyan;
        let l_navBarIconLavender: string = DefaultColors.navBarIconLavender;
        let l_navBarIconPeach: string = DefaultColors.navBarIconPeach;
        let l_navBarIconGray: string = DefaultColors.navBarIconGray;

        // Primary
        this.setDocumentStyle(ColorVariable.primary, l_PrimaryColor);
        // this.setDocumentStyle(ColorVariable.primaryRGB, l_PrimaryRGB);
        this.setDocumentStyle(ColorVariable.primaryButton, l_primaryButton);

        // Secondary
        this.setDocumentStyle(ColorVariable.secondary, l_Secondary);

        // Font Color
        this.setDocumentStyle(ColorVariable.font, l_FontColor);
        this.setDocumentStyle(ColorVariable.fontTitle, l_FontTitleColor);
        this.setDocumentStyle(ColorVariable.dataHeader, l_dataHeader);
        this.setDocumentStyle(ColorVariable.data, l_data);
        this.setDocumentStyle(ColorVariable.errorFont, l_errorFont);
        this.setDocumentStyle(ColorVariable.inputPlaceHolderText, l_inputPlaceHolderText);
        this.setDocumentStyle(ColorVariable.instructionContainerFontColor, l_instructionContainerFontColor);
        this.setDocumentStyle(ColorVariable.materialFont, l_materialFont);
        this.setDocumentStyle(ColorVariable.hyperLinkColor, l_hyperLinkColor);
        this.setDocumentStyle(ColorVariable.headerButtonFontColor, l_headerButtonFontColor);
        this.setDocumentStyle(ColorVariable.formLabel, l_formLabel);
        this.setDocumentStyle(ColorVariable.devxlabelOne, l_devxlabelOne);
        this.setDocumentStyle(ColorVariable.devxlabelTwo, l_devxlabelTwo);

        // Background
        this.setDocumentStyle(ColorVariable.background, l_Background);
        this.setDocumentStyle(ColorVariable.inputBackground, l_inputBackground);
        this.setDocumentStyle(ColorVariable.errorBackground, l_errorBackground);
        this.setDocumentStyle(ColorVariable.loadingBackground, l_loadingBackground);
        this.setDocumentStyle(ColorVariable.contentContainerBackground, l_contentContainerBackground);
        this.setDocumentStyle(ColorVariable.contentHeaderNoteBackground, l_contentHeaderNoteBackground);
        this.setDocumentStyle(ColorVariable.checkboxSelectedBackground, l_checkboxSelectedBackground);
        this.setDocumentStyle(ColorVariable.checkboxUnselectedBackground, l_checkboxUnselectedBackground);
        this.setDocumentStyle(ColorVariable.payStubTotalBackground, l_payStubTotalBackground);
        this.setDocumentStyle(ColorVariable.materialFormDisabledbackground, l_materialFormDisabledbackground);
        this.setDocumentStyle(ColorVariable.childTableRowBackground, l_childTableRowBackground);
        this.setDocumentStyle(ColorVariable.childTableBackground, l_childTableBackground);
        this.setDocumentStyle(ColorVariable.headerFooterBackground, l_headerFooterBackground);
        this.setDocumentStyle(ColorVariable.headerSeperator, l_headerSeperator);
        this.setDocumentStyle(ColorVariable.headerBoxShadow, l_headerBoxShadow);
        this.setDocumentStyle(ColorVariable.subHeaderBackground, l_subHeaderBackground);

        // Button
        this.setDocumentStyle(ColorVariable.buttonMenuLinkHovered, l_buttonMenuLinkHovered);
        this.setDocumentStyle(ColorVariable.buttonRegisterFontReg, l_buttonRegisterFontReg);
        this.setDocumentStyle(ColorVariable.buttonRegisterFontHovered, l_buttonRegisterFontHovered);
        this.setDocumentStyle(ColorVariable.buttonRegisterHovered, l_buttonRegisterHovered);
        this.setDocumentStyle(ColorVariable.buttonPrimaryFontReg, l_buttonPrimaryFontReg);
        this.setDocumentStyle(ColorVariable.buttonPrimaryFontHovered, l_buttonPrimaryFontHovered);
        this.setDocumentStyle(ColorVariable.buttonPrimaryFontActive, l_buttonPrimaryFontActive);
        this.setDocumentStyle(ColorVariable.buttonPrimaryFontDisabled, l_buttonPrimaryFontDisabled);
        this.setDocumentStyle(ColorVariable.buttonPrimaryBackgroundReg, l_buttonPrimaryBackgroundReg);
        this.setDocumentStyle(ColorVariable.buttonPrimaryBackgroundHovered, l_buttonPrimaryBackgroundHovered);
        this.setDocumentStyle(ColorVariable.buttonPrimaryBackgroundActive, l_buttonPrimaryBackgroundActive);
        this.setDocumentStyle(ColorVariable.buttonPrimaryBackgroundDisabled, l_buttonPrimaryBackgroundDisabled);
        this.setDocumentStyle(ColorVariable.buttonSecondaryFontReg, l_buttonSecondaryFontReg);
        this.setDocumentStyle(ColorVariable.buttonSecondaryFontHovered, l_buttonSecondaryFontHovered);
        this.setDocumentStyle(ColorVariable.buttonSecondaryFontActive, l_buttonSecondaryFontActive);
        this.setDocumentStyle(ColorVariable.buttonSecondaryFontDisabled, l_buttonSecondaryFontDisabled);
        this.setDocumentStyle(ColorVariable.buttonSecondaryBackgroundHovered, l_buttonSecondaryBackgroundHovered);
        this.setDocumentStyle(ColorVariable.buttonSecondaryBackgroundActive, l_buttonSecondaryBackgroundActive);


        // Other
        this.setDocumentStyle(ColorVariable.border, l_border);
        this.setDocumentStyle(ColorVariable.radioButtonUnselected, l_radioButtonUnselected);
        this.setDocumentStyle(ColorVariable.radioButtonSelected, l_radioButtonSelected);
        this.setDocumentStyle(ColorVariable.toggleButtonSelected, l_toggleButtonSelected);
        this.setDocumentStyle(ColorVariable.materialFieldBorder, l_materialFieldBorder);
        this.setDocumentStyle(ColorVariable.appDividerContainer, l_appDividerContainer);
        this.setDocumentStyle(ColorVariable.materialFormDisabledFont, l_materialFormDisabledFont);
        this.setDocumentStyle(ColorVariable.materialFormDisabledBorder, l_materialFormDisabledBorder);
        this.setDocumentStyle(ColorVariable.tableBorder, l_tableBorder);
        this.setDocumentStyle(ColorVariable.footerBorderColor, l_footerBorderColor);
        this.setDocumentStyle(ColorVariable.dropdownIcon, l_dropdownIcon);
        this.setDocumentStyle(ColorVariable.selectionContentActive, l_selectionContentActive);

        // New Controls
        this.setDocumentStyle(ColorVariable.newControlEnabledBackground, l_newControlEnabledBackground);
        this.setDocumentStyle(ColorVariable.newControlEnabledBorder, l_newControlEnabledBorder);
        this.setDocumentStyle(ColorVariable.newControlEnabledUnselected, l_newControlEnabledUnselected);
        this.setDocumentStyle(ColorVariable.newControlEnabledSelected, l_newControlEnabledSelected);

        this.setDocumentStyle(ColorVariable.newControlDisabledBackground, l_newControlDisabledBackground);
        this.setDocumentStyle(ColorVariable.newControlDisabledBorder, l_newControlDisabledBorder);
        this.setDocumentStyle(ColorVariable.newControlDisabledUnselected, l_newControlDisabledUnselected);
        this.setDocumentStyle(ColorVariable.newControlDisabledSelected, l_newControlDisabledSelected);

        // Toastr
        this.setDocumentStyle(ColorVariable.toastSucces, l_toastSucces);
        this.setDocumentStyle(ColorVariable.toastSuccesBackground , l_toastSuccesBackground );
        this.setDocumentStyle(ColorVariable.toastError, l_toastError );
        this.setDocumentStyle(ColorVariable.toastErrorBackground, l_toastErrorBackground);
        this.setDocumentStyle(ColorVariable.toastInfo, l_toastInfo);
        this.setDocumentStyle(ColorVariable.toastInfoBackground, l_toastInfoBackground);
        this.setDocumentStyle(ColorVariable.toastWarning, l_toastWarning);
        this.setDocumentStyle(ColorVariable.toastWarningBackground , l_toastWarningBackground );


        //In Page NavBar Icon Backgrounds
        this.setDocumentStyle(ColorVariable.navBarIconBlue, l_navBarIconBlue);
        this.setDocumentStyle(ColorVariable.navBarIconMint, l_navBarIconMint);
        this.setDocumentStyle(ColorVariable.navBarIconCoral, l_navBarIconCoral);
        this.setDocumentStyle(ColorVariable.navBarIconCyan, l_navBarIconCyan);
        this.setDocumentStyle(ColorVariable.navBarIconLavender, l_navBarIconLavender);
        this.setDocumentStyle(ColorVariable.navBarIconPeach, l_navBarIconPeach);
        this.setDocumentStyle(ColorVariable.navBarIconGray, l_navBarIconGray);
    }

    public setDocumentStyle(styleName: string, styleValue: string): void {
        document.documentElement.style.setProperty(styleName, styleValue);
    }

    public removeStyle(styleName: string): void {
        document.documentElement.style.removeProperty(styleName);
    }
}